import { render, staticRenderFns } from "./LeadTask.vue?vue&type=template&id=5cbc810e&scoped=true&"
import script from "./LeadTask.vue?vue&type=script&lang=js&"
export * from "./LeadTask.vue?vue&type=script&lang=js&"
import style0 from "./LeadTask.vue?vue&type=style&index=0&id=5cbc810e&prod&lang=scss&scoped=true&"
import style1 from "./LeadTask.vue?vue&type=style&index=1&id=5cbc810e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc810e",
  null
  
)

export default component.exports